import React, { useEffect, useState } from 'react';
import OrgSignupDetails from './OrgSignupDetails';
import { getLeadsDetailsApi } from '../../redux/Reducers/commonApis';
import { useDispatch } from 'react-redux';
import { setGroupDataAction } from '../../redux/Actions/GroupActions';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

function OrgSignup() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentURL = new URL(window.location.href);
  const urlParams = new URLSearchParams(currentURL.search);
  const [loading, setLoading] = useState(false);
  const token = urlParams.get('token');
  const [leadData, setLeadData] = useState(null);
  const getLeadsDetailsApiFn = (data) => {
    setLoading(true);
    const response = getLeadsDetailsApi(data);
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        setLeadData(res?.data);
        setLoading(false);
      } else {
        if (res?.status === 400 && res?.message === 'Token is not active.') {
          toast.error('Token is not active. Please sign in.');
          navigate('/signin');
        } else if (res?.error?.message) {
          toast.error(res.error.message);
        } else {
          toast.error('Something went wrong');
        }
        setLoading(false);
      }
    });
  };
  useEffect(() => {
    token && getLeadsDetailsApiFn({ token: token });
  }, [token]);
  return <OrgSignupDetails token={token} loading={loading} data={leadData} />;
}

export default OrgSignup;
